'use strict';

var HeaderView = require('modules/collection/views/layout/header');

var template = require('../../templates/layout/header.hbs');

var ShareHeaderView = HeaderView.extend({
    template: template,

    viewData: {
        objectCount: function() {
            return this.collection.length;
        },
    },

    /**
     *
     * @returns {string} Unescaped Text
     */
    getHeadline: function () {
        var shareModel = this.getOption('shareModel');

        switch (shareModel.get('type')) {
            case 'set':
                return App.t('share::headline:set', {title: shareModel.get('title')});
            case 'location':
                return App.t('share::headline:location', {title: shareModel.get('title')});
            case 'object':
                return App.t('share::headline:object', {title: shareModel.get('title')});
            default:
                return shareModel.get('title');
        };
    },

    /**
     *
     * @returns {string} Unescaped Text
     */
    getSubline: function () {
        var fullname = this.getOption('shareModel').get('fullname');

        return App.t('collection::objects:count', this.collection.length) + (fullname ? ' ' + App.t('share::subheadline:attribution', {name: fullname}) : '');
    },
});

module.exports = ShareHeaderView;